import { StyleSheet, Text, View } from 'react-native';
import React, { FC, useCallback } from 'react';
import { SportBookingType } from '../types';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Image } from '../../../components/Image';
import { Button } from '../../../components/Button';
import { NavigationService } from '../../../services/navigation';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { FONTS } from '../../../constants';
import { IFacilities } from '../../../types/sports.types';
import { convertToAmPm } from '../../../services/utils';

interface SportBookingProps {
  booking: IFacilities;
}

const SportBooking: FC<SportBookingProps> = ({ booking }) => {
  const isDesktop = useIsDesktop();

  const handleRedirectDetail = useCallback(() => {
    NavigationService.push<'Root'>('Root', {
      screen: 'MenuTab',
      params: {
        screen: 'CourtDetail',
        params: {
          sheet: booking.bs_no,
          court: booking.is_sub ? booking.fac_ecode : '',
        },
      },
    });
  }, [booking]);

  const styles = StyleSheet.create({
    wrapper: {
      padding: isDesktop() ? 12 : 8,
      flex: isDesktop() ? 0.5 : undefined,
      minWidth: isDesktop() ? 320 : undefined,
      flexDirection: 'row',
      borderWidth: isDesktop() ? 2 : 1,
      borderColor: STYLE_VARS.primaryColor,
      borderRadius: 4,
      backgroundColor: 'white',
      marginBottom: isDesktop() ? 0 : 15,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowOpacity: 0.5,
      shadowRadius: 13.5,
      elevation: 5,
    },
    headerText: {
      fontSize: 16,
      letterSpacing: 1,
      fontFamily: FONTS.IowanOldStyleBTRoman,
      color: STYLE_VARS.textColor,
      textTransform: 'uppercase',
    },
    textStyled: {
      fontSize: 13,
      letterSpacing: 1,
      fontFamily: FONTS.IowanOldStyleBTRoman,
      color: STYLE_VARS.textColor,
      textTransform: 'uppercase',
    },
  });
  return (
    <View style={styles.wrapper}>
      <Image
        source={{ uri: booking.image }}
        style={{
          width: 150,
          height: 120,
          resizeMode: 'cover',
          marginRight: 8,
        }}
        onPress={handleRedirectDetail}
      />
      <View style={{ flex: 1, flexDirection: 'column' }}>
        <View style={{ flex: 1, flexDirection: 'column' }}>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              paddingVertical: 5,
            }}
          >
            <Text
              style={styles.headerText}
              onPress={handleRedirectDetail}
            >{booking.bs_desc}</Text>
          </View>
          <Text style={styles.textStyled}>OPENING HOURS</Text>
          <Text
            style={[styles.textStyled, { color: STYLE_VARS.fccDarkerGrey }]}
          >
            {booking.opening_hours}
          </Text>
        </View>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: isDesktop() ? 'flex-end' : undefined,
          }}
        >
          <Button
            text="BOOK NOW"
            style={
              isDesktop() ? STYLE_VARS.blueButton : STYLE_VARS.fullWGreenButton
            }
            onPress={handleRedirectDetail}
          />
        </View>
      </View>
    </View>
  );
};

export default SportBooking;
